/**
 * Definition Id of text shape.
 */
export const TEXT_SHAPE_DEF_ID = 'creately.basic.text';